module.exports = __webpack_public_path__ + "img/illustrations5.07a6fd48.jpg";